import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function TrabajosCiclo() {
  return <ServiceTemplate serviceName="trabajos-ciclo" />;
}
